import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import ILocalState from './stateInterface';

const initState: ILocalState = {
    productCodeSystemList: null,
    productSearchResults: null,
    filteredSearchResults: [],
    filterOptions: null,
    searchKeywords: '',
    singleFolder: [],
    expandViaCpcs: [],
    searchCpcs: '',
    savedSearches: null,
    filterData: null,
    totalResults: 0,
    technologyTotalItems: '',
    softwareTotalItems: '',
    goodwillTotalItems: '',
    trademarkTotalItems: '',
    customerTotalItems: ''
};

export default {
    namespaced: true,
    state: initState,
    getters,
    actions,
    mutations,
};
